(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight = this.setHeaderHeight.bind(this);
      this.onPasswordUnlock = this.onPasswordUnlock.bind(this);

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      document.addEventListener('collection-password:unlocked', this.onPasswordUnlock);

      if (window.ResizeObserver) {
        this.headerResizeObserver = new ResizeObserver(this.setHeaderHeight);
        this.headerResizeObserver.observe(this.header);
      }

      this.initTransparentHeader();
      this.createObserver();
      this.syncTransparentHeader();
    }

    initTransparentHeader() {
      if (this.getAttribute('data-transparent-header') !== 'true') return;
      if (!document.querySelector('#MainContent .section--header-overlay')) return;

      document.body.classList.add('transparent-header-enabled');
      this.solidScheme = this.getAttribute('data-color-scheme');
      this.transparentScheme = this.getAttribute('data-transparent-color-scheme');
    }

    syncTransparentHeader() {
      if (!document.body.classList.contains('transparent-header-enabled')) return;

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const threshold = this.headerBounds.bottom || this.header.offsetHeight;
      const overlayActive = scrollTop <= threshold;
      document.body.classList.toggle('transparent-header-active', overlayActive);

      if (this.solidScheme && this.transparentScheme) {
        this.classList.remove(`color-${this.solidScheme}`, `color-${this.transparentScheme}`);
        this.classList.add(`color-${overlayActive ? this.transparentScheme : this.solidScheme}`);
      }
    }

    onPasswordUnlock() {
      this.initTransparentHeader();
      this.setHeaderHeight();
      this.syncTransparentHeader();
    }

    setHeaderHeight() {
      const height = this.header.offsetHeight;
      if (!height || height === this.lastHeaderHeight) return;

      this.lastHeaderHeight = height;
      document.documentElement.style.setProperty('--header-height', `${height}px`);

      if (document.body.classList.contains('transparent-header-enabled')) {
        this.headerBounds = { top: 0, bottom: height, left: 0, right: 0, height, width: 0, x: 0, y: 0 };
        this.syncTransparentHeader();
      }
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      document.removeEventListener('collection-password:unlocked', this.onPasswordUnlock);
      if (this.headerResizeObserver) this.headerResizeObserver.disconnect();
    }

    createObserver() {
      if (document.body.classList.contains('transparent-header-enabled')) {
        const height = this.header.offsetHeight;
        if (height) {
          this.headerBounds = { top: 0, bottom: height, left: 0, right: 0, height, width: 0, x: 0, y: 0 };
        }
        return;
      }

      const observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      this.syncTransparentHeader();

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
